import {API} from 'aws-amplify';

// @ts-ignore
export const read = async () => API.get('robinhoodEngAdminApi', '/users', {});

// @ts-ignore
export const readOne = async (id) => API.get('robinhoodEngAdminApi', `/users/${id}`, {});
